import React from 'react'
import { useSelector } from 'hooks/use-redux'
import { Link } from 'react-router-dom'
import {
  getCorePlan,
  getUsersLimits,
} from '@disco/state-management/selectors/user'
import Alert from 'components/ui/alert'

const OverQuotaAlert = (): null | React.ReactNode => {
  const usersLimits = useSelector(getUsersLimits)
  const plan = useSelector(getCorePlan)
  if (!usersLimits.overQuota) return null
  return (
    <Alert status="warning" icon="warning">
      <span>
        You are at your quota! You have {usersLimits.maxAsDisplayString}{' '}
        <span>{usersLimits.max === 1 ? 'seat' : 'seats'}</span>
        <span> on your {plan?.name} plan, and are currently using </span>
      </span>
      <span
        style={
          usersLimits.current > usersLimits.max
            ? {
                color: '#FD7D69',
              }
            : undefined
        }
      >
        {usersLimits.current}{' '}
        <span>{usersLimits.current === 1 ? 'seat' : 'seats'}</span>
      </span>
      <span>. To invite additional users, please add seats below, or </span>
      <Link className="text-link" to="/settings/users">
        remove users.
      </Link>
    </Alert>
  )
}

export default OverQuotaAlert
